<template>
  <v-content v-if="!curriculum" class="fill-height white">
    <v-progress-linear indeterminate></v-progress-linear>
  </v-content>
  <Curriculum v-else :curriculum="curriculum" id="print-curriculum" />
</template>

<script>
import { mapState } from "vuex";

import Curriculum from "@/components/Curriculum";
import store from "@/store";

export default {
  props: {
    postulante: {
      type: String,
      required: true
    }
  },
  components: {
    Curriculum
  },
  data() {
    return {
      loading: true,
      curriculum: undefined
    };
  },
  mounted() {
    this.getCurriculum();
  },
  methods: {
    getCurriculum() {
      store
        .dispatch("administration/postulants/retrievePostulantById", {
          postulante: this.postulante
        })
        .then(curriculum => {
          const elementCurriculum = document.getElementById("print-curriculum");

          console.log(curriculum);

          this.curriculum = curriculum;
          console.log(this.postulante);
          
          this.toDataURL(
            this.curriculum.informacion_personal.profile_image,
            dataUrl => {
              setTimeout(() => {
                this.print();
              }, 2000);
            }
          );
        })
        .finally(() => {});
    },
    print() {
      window.print();
      window.close();
    },
    toDataURL(url, callback) {
      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = function(event) {
        const blob = xhr.response;
        callback(url);
      };
      xhr.onerror = function(event) {
        callback(url);
      };
      xhr.open("GET", url);
      xhr.send();
    }
  }
};
</script>

<style>
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 1.06cm;
  }
}
@page {
  margin: 0;
}
</style>